import { jsx as o } from "react/jsx-runtime";
import r from "@mui/icons-material/Close";
import { ChipDelete as t } from "@mui/joy";
import i from "@mui/joy/Chip";
import e from "@mui/joy/Typography";
const a = ({ id: a2, value: n, onDelete: l, disabled: p, invalid: m }) => {
  const d = m ? "danger" : "primary";
  return o(i, { size: "sm", variant: p ? "outlined" : "soft", sx: { cursor: "pointer", background: (o2) => `${o2.palette[d][m ? 100 : 50]} !important`, "&.Mui-disabled": { ".MuiTypography-root": { color: "neutral.400" }, background: (o2) => `${o2.palette.neutral[50]} !important` } }, disabled: p, endDecorator: !p && l ? o(t, { id: a2, variant: "plain", component: "span", onClick: (o2) => {
    o2.stopPropagation(), l(a2);
  }, sx: { background: (o2) => `${o2.palette[d][m ? 100 : 50]} !important`, "&:hover": { background: (o2) => `${o2.palette[d][m ? 200 : 100]} !important` } }, children: o(r, { sx: { width: 18, height: 18, color: (o2) => `${o2.palette[d][600]} !important` } }) }) : null, children: o(e, { level: "body-xs", sx: { color: `${d}.600` }, children: n }) });
};
export {
  a as ChipItem
};
//# sourceMappingURL=ChipItem.js.map
